import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,[_c(VCol,{attrs:{"cols":"12","lg":"12","md":"12","xs":"12"}},[_c(VSimpleTable,{attrs:{"fixed-header":_vm.tableFixedHeader,"height":_vm.tableHeight + 'px'},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',[_c('tr',[(_vm.tableThumbColumn)?_c('th',{staticClass:"text-left"},[_vm._v("\n                "+_vm._s(_vm.selectedLang[_vm.lang].table.thumb)+"\n              ")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.selectedLang[_vm.lang].table.name))]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.selectedLang[_vm.lang].table.size))]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("\n                "+_vm._s(_vm.selectedLang[_vm.lang].table.action.action)+"\n              ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.documentAttachment),function(attachment,index){return _c('tr',{key:`attachment-${index}`},[(_vm.tableThumbColumn)?_c('td',[(
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() == 'jpg' ||
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() == 'jpeg' ||
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() == 'png' ||
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() == 'tif' ||
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() == 'bmp'
                  )?[(_vm.thumb)?_c(VImg,{staticStyle:{"margin":"10px"},attrs:{"src":'data:' +
                        attachment.file.format +
                        ',' +
                        attachment.file.base64,"height":"50px","width":"50px"}}):_c(VIcon,{staticStyle:{"margin-left":"10px"},attrs:{"size":"50","file-word-outline":"","color":"deep-purple darken-1"}},[_vm._v("mdi-file-image-outline")])]:[(
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() === 'pdf'
                    )?_c(VIcon,{staticStyle:{"margin-left":"10px"},attrs:{"size":"50","file-word-outline":"","color":"red darken-1"}},[_vm._v("mdi-file-pdf-outline")]):(
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() === 'doc' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'docx' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'odt'
                    )?_c(VIcon,{staticStyle:{"margin-left":"10px"},attrs:{"size":"50","file-word-outline":"","color":"blue darken-1"}},[_vm._v("mdi-file-word-outline")]):(
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() === 'xls' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'xlsx'
                    )?_c(VIcon,{staticStyle:{"margin-left":"10px"},attrs:{"size":"50","file-word-outline":"","color":"teal darken-1"}},[_vm._v("mdi-file-excel-outline")]):(
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() === 'pptx' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'pptm' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'ppt'
                    )?_c(VIcon,{staticStyle:{"margin-left":"10px"},attrs:{"size":"50","file-word-outline":"","color":"orange darken-3"}},[_vm._v("mdi-file-powerpoint-outline")]):(
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() === 'mp4' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'mov' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'flv' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'wmv' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'avi'
                    )?_c(VIcon,{staticStyle:{"margin-left":"10px"},attrs:{"size":"50","file-word-outline":"","color":"red lighten-1"}},[_vm._v("mdi-file-video-outline")]):(
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() === 'dwg'
                    )?_c(VIcon,{staticStyle:{"margin-left":"10px"},attrs:{"size":"50","file-word-outline":"","color":"indigo lighten-2"}},[_vm._v("mdi-file-cad")]):(
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() === 'zip' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === 'rar' ||
                        attachment.file.name
                          .split('.')
                          .pop()
                          .toLowerCase() === '7-zip'
                    )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"lime lighten-1"}},[_vm._v("mdi-folder-zip-outline")]):(
                      attachment.file.name
                        .split('.')
                        .pop()
                        .toLowerCase() === 'txt'
                    )?_c(VIcon,{staticStyle:{"margin-left":"10px"},attrs:{"size":"50","file-word-outline":"","color":"light-green darken-3"}},[_vm._v("mdi-script-text-outline")]):_c(VIcon,{attrs:{"x-large":"","file-word-outline":"","color":"indigo lighten-1"}},[_vm._v("mdi-file-question-outline")])]],2):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(attachment.file.name))]),_vm._v(" "),_c('td',[(
                    Number((attachment.file.size / 1000).toFixed(1)) < 1024
                  )?_c(VCardSubtitle,{staticClass:"mt2"},[_c(VChip,{attrs:{"color":"teal lighten-2","label":"","text-color":"white"}},[_vm._v("\n                    "+_vm._s(Number((attachment.file.size / 1000).toFixed(1)) +
                        _vm.selectedLang[_vm.lang].size.kb)+"\n                    "),_c(VIcon,{attrs:{"right":""}},[_vm._v("mdi-harddisk")])],1)],1):_vm._e(),_vm._v(" "),(
                    Number((attachment.file.size / 1000).toFixed(1)) > 1024
                  )?_c(VCardSubtitle,[_c(VChip,{attrs:{"color":"teal lighten-2","label":"","text-color":"white"}},[_vm._v("\n                    "+_vm._s(Number(
                        (attachment.file.size / 1000 / 1024).toFixed(1)
                      ) + _vm.selectedLang[_vm.lang].size.mb)+"\n                    "),_c(VIcon,{attrs:{"right":""}},[_vm._v("mdi-harddisk")])],1)],1):_vm._e()],1),_vm._v(" "),_c('td',[_c(VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [(_vm.deletePermission)?_c(VBtn,_vm._g({attrs:{"icon":"","color":"red"},on:{"click":function($event){return _vm.openDeleteDialog(index, '')}}},on),[_c(VIcon,[_vm._v("mdi-delete")])],1):_vm._e()]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedLang[_vm.lang].table.action.deleteTooltip))])]),_vm._v(" "),_c(VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [(_vm.editPermission)?_c(VBtn,_vm._g({attrs:{"text":"","fab":""},on:{"click":function($event){return _vm.openEditDocumentDialog(attachment, index)}}},on),[_c(VIcon,{attrs:{"color":"green"}},[_vm._v("mdi-pencil-outline")])],1):_vm._e()]}}],null,true)},[_vm._v(" "),_c('span',{staticClass:"BYekan"},[_vm._v(_vm._s(_vm.selectedLang[_vm.lang].edit))])])],1)])}),0)]},proxy:true}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }